import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { ParticipationMode } from "../models/entities/EntityEnum";

export const groupParticipantsValidator: ValidatorFn = (
    control: AbstractControl
): ValidationErrors | null => {
    const participationMode = control.get("participationMode")?.value;
    const participants = control.get("groupParticipant")?.value as any[];

    if (
        participationMode === ParticipationMode.GROUP &&
        (!participants || participants.length == 0 || participants.length > 3)
    ) {
        return {
            minGroupParticipants: {
                required: 3,
                actual: participants?.length || 0,
            },
        };
    }

    return null;
};
